// extracted by mini-css-extract-plugin
export default {"panel":"form-fields-panel_panel__Lw--I"};